var map = {
	"./File.svg": "ctWH",
	"./arrow_right.svg": "fQpn",
	"./blog_arrow_right.svg": "SlbP",
	"./blog_banner_logo.svg": "tg7o",
	"./blog_detail_facebook.svg": "nZ51",
	"./blog_detail_ins.svg": "BGl7",
	"./blog_detail_x.svg": "RY9X",
	"./book.svg": "UDoE",
	"./book_open.svg": "HOuR",
	"./check_magenta.svg": "5nRd",
	"./check_right.svg": "eyB+",
	"./console_award.svg": "glxZ",
	"./console_check_circle.svg": "ZCTL",
	"./console_feather.svg": "SbmU",
	"./console_users.svg": "JQkB",
	"./database.svg": "Nujs",
	"./email.svg": "P179",
	"./fb.svg": "PSa7",
	"./finance_report.svg": "PhyM",
	"./grid.svg": "Eo4W",
	"./headphones.svg": "LJXs",
	"./info.svg": "zEfD",
	"./ins.svg": "b3Ae",
	"./lg.svg": "n0Kt",
	"./lg_white.svg": "Jiqx",
	"./message_circle.svg": "eb8H",
	"./minus.svg": "xZGA",
	"./monitor.svg": "aONn",
	"./offline_pay.svg": "JXZS",
	"./phone.svg": "vSi7",
	"./plus.svg": "Y6EP",
	"./plus_circle_magenta.svg": "UpM9",
	"./pos_app.svg": "sHMb",
	"./pos_credit_card.svg": "Wp2C",
	"./pos_database.svg": "y4NJ",
	"./pos_gift.svg": "YXCv",
	"./pos_shopping_bag.svg": "cLU5",
	"./pos_wifi.svg": "cjZc",
	"./quick.svg": "MFpA",
	"./realtime_record.svg": "g3dl",
	"./remote_manage.svg": "LmG0",
	"./simple.svg": "x/T/",
	"./smile.svg": "YKZ4",
	"./transparent.svg": "eqJI",
	"./wonder_blog_arrow_left.svg": "zfxJ",
	"./x.svg": "f+kQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "506h";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/icon/svg ^\.\/.*\.svg$
// module id = 506h
// module chunks = 8